/* Presentation only: native variant, upload, builder and cart owners stay intact. */
(() => {
  const mount = () => {
    const root = document.querySelector('[data-fp-gang-studio]');
    const shell = document.querySelector('[id^="MainProduct-"]');
    const info = shell?.querySelector('product-info');
    const media = shell?.querySelector('.product__media-wrapper');
    if (!root || !info || !media || root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const visual = root.querySelector('[data-fgs-visual]');
    media.prepend(root.querySelector('[data-fgs-heading]'));
    info.prepend(root.querySelector('[data-fgs-config]'));
    media.append(visual);
    shell.append(root.querySelector('[data-fgs-details]'));
    const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
    const mode = root.dataset.mode;
    document.documentElement.classList.add('fp-gang-studio', mode === 'upload' ? 'fp-gang-upload-page-static' : 'fp-gang-builder-page');
    document.documentElement.dataset.fgsMode = mode;
    document.documentElement.dataset.fgsMaterial = root.dataset.material;
    // Native product navigation swaps the full material description and preserves Shopify's forms.
    const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
    if (previewTheme) document.querySelectorAll('[data-fgs-route]').forEach(link => {
      const url = new URL(link.href, location.origin);
      url.searchParams.set('preview_theme_id', previewTheme);
      link.href = url.href;
    });
    const variants = JSON.parse(root.querySelector('[data-fgs-variants]').textContent || '[]');
    const nativePicker = info.querySelector('variant-radios, variant-selects');
    const sizeHeading = document.createElement('h2');
    sizeHeading.className = 'fgs-step fgs-step--size';
    sizeHeading.innerHTML = '<span>02</span> Choose your sheet size';
    (info.querySelector('[data-fp-size-picker]') || nativePicker)?.before(sizeHeading);
    let uploadSize = null;
    if (mode === 'upload' && nativePicker) {
      const radios = [...nativePicker.querySelectorAll('input[type="radio"]')];
      const sourceSelect = nativePicker.querySelector('select');
      // Only the single-option gang sheet products get this presentation control.
      const optionGroups = new Set(radios.map(input => input.name));
      if ((radios.length && optionGroups.size === 1) || (!radios.length && sourceSelect)) {
        const label = document.createElement('label');
        label.className = 'fgs-size-select';
        label.htmlFor = 'fgs-upload-size';
        const hint = document.createElement('span');
        hint.textContent = root.dataset.material === '3' ? '12″ UV format · sheet size' : `${root.dataset.width}″ wide · sheet length`;
        uploadSize = document.createElement('select');
        uploadSize.id = 'fgs-upload-size';
        const sources = radios.length ? radios : [...sourceSelect.options];
        sources.forEach(source => {
          const option = document.createElement('option');
          const variant = variants.find(item => item.options[0] === source.value);
          option.value = source.value;
          const price = variant ? new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(variant.price / 100) : '';
          option.textContent = `${source.value}${price ? ' · ' + price : ''}`;
          option.disabled = source.disabled || variant?.available === false;
          option.selected = radios.length ? source.checked : source.selected;
          uploadSize.append(option);
        });
        uploadSize.addEventListener('change', () => {
          if (radios.length) radios.find(input => input.value === uploadSize.value)?.click();
          else { sourceSelect.value = uploadSize.value; sourceSelect.dispatchEvent(new Event('change', {bubbles:true})); }
        });
        label.append(hint, uploadSize);
        nativePicker.before(label);
        nativePicker.classList.add('fgs-native-size-source');
      }
    }

    const stepThree = document.createElement('h2');
    stepThree.className = 'fgs-step fgs-step--art';
    stepThree.innerHTML = '<span>03</span> ' + (mode === 'build' ? 'Build your sheet' : 'Add your artwork');
    const builder = info.querySelector('[id^="freshtools-checkout-"]');
    const uploadForm = [...info.querySelectorAll('form[action*="/cart/add"]')].find(form => form.querySelector('[name="add"],button[type="submit"]'));
    // A heading may be inserted; the original roots and form controls are never moved/cloned.
    if (builder) builder.prepend(stepThree);
    else if (uploadForm) uploadForm.prepend(stepThree);
    // Keep native forms in place. These buttons reveal their existing sections on phones.
    const compact = matchMedia('(max-width: 1099px)');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const scrollToSetup = () => {
      if (compact.matches) tabs.scrollIntoView({block:'start', behavior:reducedMotion.matches ? 'auto' : 'smooth'});
    };
    const tabs = document.createElement('nav');
    tabs.className = 'fgs-mobile-tabs';
    tabs.setAttribute('aria-label', 'Order setup');
    tabs.innerHTML = '<button type="button" data-fgs-tab="material" aria-pressed="true"><span>01</span> Material</button><button type="button" data-fgs-tab="size" aria-pressed="false"><span>02</span> Sheet size</button><button type="button" data-fgs-tab="order" aria-pressed="false"><span>03</span> ' + (mode === 'build' ? 'Build' : 'Order') + '</button>';
    let activePanel = 'material';
    const markPanels = () => {
      const sizeControl = info.querySelector('[data-fp-size-picker], .fgs-size-select') || nativePicker;
      // The app can move its native picker into a shared builder block after mount.
      // Follow it with only our heading, and leave every native control in place.
      if (sizeControl?.isConnected && sizeControl.previousElementSibling !== sizeHeading) sizeControl.before(sizeHeading);
      const anchors = [
        [info.querySelector('[data-fgs-config]'), 'material'],
        [sizeHeading, 'size'],
        [sizeControl, 'size'],
        [nativePicker, 'size'],
        [info.querySelector('[id^="freshtools-checkout-"]') || uploadForm, 'order'],
      ].filter(([node]) => node && info.contains(node));
      const desired = new Map();
      const visit = (parent, panel) => {
        for (const node of parent.children) {
          if (node === tabs || ['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(node.tagName)) continue;
          const containedPanels = new Set(anchors.filter(([anchor]) => node === anchor || node.contains(anchor)).map(([, owner]) => owner));
          if (containedPanels.size > 1) {
            // A mixed app wrapper must remain visible; only its owned sections switch.
            panel = visit(node, panel);
          } else {
            if (containedPanels.size) panel = [...containedPanels][0];
            desired.set(node, panel);
          }
        }
        return panel;
      };
      visit(info, 'material');
      info.querySelectorAll('[data-fgs-panel]').forEach(node => {
        if (!desired.has(node)) delete node.dataset.fgsPanel;
      });
      desired.forEach((panel, node) => {
        if (node.dataset.fgsPanel !== panel) node.dataset.fgsPanel = panel;
      });
    };
    markPanels();
    info.dataset.fgsActive = activePanel;
    info.prepend(tabs);
    // Keep the selected swatch visible without moving the page or changing materials.
    const revealMaterial = () => {
      const row = info.querySelector('.fgs-materials');
      const selected = row?.querySelector('[aria-current]');
      if (row && selected) row.scrollLeft = Math.max(0, row.scrollLeft + selected.getBoundingClientRect().left - row.getBoundingClientRect().left - (row.clientWidth - selected.clientWidth) / 2);
    };
    requestAnimationFrame(revealMaterial);
    const setPanel = (panel, focus = false) => {
      activePanel = panel;
      info.dataset.fgsActive = panel;
      tabs.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fgsTab === panel)));
      syncPurchase();
      if (focus) scrollToSetup();
    };
    const revealActiveBuilder = () => {
      // Saved-file and sign-in return links can open the app without clicking our bar.
      if (activePanel !== 'order' && info.querySelector('[data-ft-workspace]:not([hidden]), [data-ft-order-dialog][open]')) setPanel('order');
    };
    tabs.addEventListener('click', event => {
      const button = event.target.closest('[data-fgs-tab]');
      if (button) setPanel(button.dataset.fgsTab, true);
    });
    visual.querySelectorAll('[data-fgs-source]').forEach(button => button.addEventListener('click', () => {
      setPanel('order', true);
      const picker = info.querySelector('[data-fp-pro-vault-picker]');
      picker?.querySelector(`[data-fp-vault-source="${button.dataset.fgsSource}"]`)?.click();
      picker?.scrollIntoView({block:'nearest', behavior:reducedMotion.matches ? 'auto' : 'smooth'});
    }));

    // A presentation bar delegates to the real button; cart validation and upload ownership stay native.
    const purchase = document.createElement('div');
    purchase.className = 'fgs-purchase';
    purchase.setAttribute('aria-label', 'Your gang sheet order');
    purchase.innerHTML = '<div class="fgs-purchase-summary"><strong data-fgs-summary></strong><span data-fgs-checkout-note>Membership savings apply in cart. </span></div><div class="fgs-purchase-price"><small>PER SHEET</small><strong data-fgs-price></strong></div><button type="button" data-fgs-purchase disabled></button>';
    const checkoutNote = info.querySelector('[data-fp-checkout-note]');
    if (checkoutNote) purchase.querySelector('[data-fgs-checkout-note]').append(document.createTextNode(checkoutNote.textContent.trim()));
    shell.querySelector('.product').after(purchase);
    const proTemplate = root.querySelector('[data-fgs-member-price]');
    if (proTemplate) purchase.querySelector('.fgs-purchase-summary').append(proTemplate.content.cloneNode(true));
    const proPrice = purchase.querySelector('fp-big-pro-price');
    const purchaseButton = purchase.querySelector('[data-fgs-purchase]');
    const sourceButton = () => builder?.querySelector('[data-ft-start]') || uploadForm?.querySelector('[name="add"],button[type="submit"]');
    const syncPurchase = () => {
      const source = sourceButton();
      const selectedOptions = [...(nativePicker?.querySelectorAll('input[type="radio"]:checked,select') || [])].map(input => input.value);
      const selectedVariant = selectedOptions.length
        ? variants.find(variant => variant.options.every((option, index) => option === selectedOptions[index]))
        : variants.find(variant => String(variant.id) === info.querySelector('input[name="id"]')?.value);
      const proCents = selectedVariant?.available && selectedVariant.price > 0 ? String(selectedVariant.price) : '';
      if (proPrice && proPrice.dataset.price !== proCents) proPrice.dataset.price = proCents;
      const nativePrice = info.querySelector('.price:not(.price--on-sale) .price-item--regular, .price.price--on-sale .price-item--sale');
      setText(purchase.querySelector('[data-fgs-price]'), nativePrice?.textContent.trim() || 'See price');
      const selectedSize = uploadSize?.selectedOptions[0]?.value || info.querySelector('[data-fp-selected-size]')?.textContent.trim() || variants.find(v => String(v.id) === info.querySelector('input[name="id"]')?.value)?.title || variants[0]?.title || '';
      const materialName = info.querySelector('.fgs-material[aria-current] strong')?.textContent || '';
      setText(purchase.querySelector('[data-fgs-summary]'), `${materialName} · ${selectedSize}`);
      const isNext = compact.matches && activePanel !== 'order';
      const sourceLabel = source?.textContent.replace(/\s+/g, ' ').trim();
      setText(purchaseButton, isNext ? (activePanel === 'material' ? 'Choose sheet size →' : mode === 'build' ? 'Continue to build →' : 'Add artwork →') : (sourceLabel || (mode === 'build' ? 'Build your sheet →' : 'Add to cart')));
      purchaseButton.disabled = !isNext && (!source || source.disabled || source.getAttribute('aria-disabled') === 'true');
      purchaseButton.setAttribute('aria-busy', source?.getAttribute('aria-busy') || 'false');
      source?.classList.add('fgs-purchase-source');
    };
    purchaseButton.addEventListener('click', () => {
      if (compact.matches && activePanel !== 'order') {
        setPanel(activePanel === 'material' ? 'size' : 'order', true);
        return;
      }
      sourceButton()?.click();
      // Reveal validation in the original form instead of bypassing its checks.
      requestAnimationFrame(() => {
        const invalid = info.querySelector('[aria-invalid="true"],input:invalid');
        if (invalid && invalid.getClientRects().length) { invalid.focus(); invalid.scrollIntoView({block:'nearest'}); }
      });
    });
    compact.addEventListener('change', () => { syncPurchase(); revealMaterial(); });
    // Browser validation can target a field in another mobile panel. Reveal it first.
    info.addEventListener('invalid', event => {
      const panel = event.target.closest('[data-fgs-panel]')?.dataset.fgsPanel;
      if (panel && panel !== activePanel) setPanel(panel);
    }, true);
    info.addEventListener('change', syncPurchase);


    const syncSize = () => {
      const selectedOptions = [...(nativePicker?.querySelectorAll('input[type="radio"]:checked,select') || [])].map(input => input.value);
      const variant = variants.find(item => item.options.every((option, index) => option === selectedOptions[index]));
      if (!variant) return;
      if (uploadSize && uploadSize.value !== variant.options[0]) uploadSize.value = variant.options[0];
      const label = visual.querySelector('[data-fgs-size]');
      setText(label, variant.title);
      const dimensions = variant.title.match(/\d+(?:\.\d+)?/g)?.map(Number);
      const paper = visual.querySelector('[data-fgs-paper]');
      if (paper && dimensions?.length >= 2) {
        const ratio = `${dimensions[0]} / ${dimensions[1]}`;
        if (paper.style.aspectRatio !== ratio) paper.style.aspectRatio = ratio;
        paper.classList.toggle('fgs-paper--long', dimensions[0] / dimensions[1] < 0.5);
      }
      shell.querySelectorAll('.fp-size-selector__helper').forEach(helper => {
        const helperCopy = root.dataset.material === '3' ? '12″ UV format · choose your sheet' : `${root.dataset.width}″ wide · choose your length`;
        if (helper.textContent !== helperCopy) helper.textContent = helperCopy;
      });
    };
    nativePicker?.addEventListener('change', syncSize);
    syncSize();
    // Mirror existing safe thumbnail URLs only. Never re-upload or change attachment IDs.
    const art = visual.querySelector('[data-fgs-art]');
    const empty = visual.querySelector('[data-fgs-empty]');
    const entry = visual.querySelector('[data-fgs-artwork-entry]');
    const paper = visual.querySelector('[data-fgs-paper]');
    const title = visual.querySelector('[data-fgs-file-title]');
    const note = visual.querySelector('[data-fgs-preview-note]');
    let failedSrc = '';
    const syncPreview = () => {
      if (!art) return;
      const picker = info.querySelector('[data-fp-pro-vault-picker]');
      const selected = picker?.querySelector('[data-fp-vault-selected-item]:not([hidden])');
      const pending = picker?.querySelector('[data-fp-vault-upload-confirmation]:not([hidden])');
      const hasOriginal = Boolean(selected || pending);
      if (entry) entry.hidden = hasOriginal;
      if (paper) paper.hidden = !hasOriginal;
      setText(empty?.querySelector('strong'), selected ? 'Original file attached' : 'Artwork selected');
      setText(empty?.querySelector('small'), 'Preview unavailable · original preserved');
      const source = selected?.querySelector('[data-fp-vault-selected-thumb] img') || pending?.querySelector('[data-fp-vault-upload-preview-image]:not([hidden])');
      const filename = selected?.querySelector('[data-fp-vault-selected-name]')?.textContent || pending?.querySelector('[data-fp-vault-upload-name]')?.textContent;
      const src = source?.getAttribute('src');
      const safe = src && /^(https?:\/\/|blob:|data:image\/(png|jpeg|webp|gif);|\/\/)/i.test(src);
      if (safe && src !== failedSrc) {
        if (art.getAttribute('src') !== src) art.src = src;
        if (art.hidden) art.hidden = false; if (!empty.hidden) empty.hidden = true;
      } else { if (!art.hidden) art.hidden = true; if (art.hasAttribute('src')) art.removeAttribute('src'); if (empty.hidden) empty.hidden = false; }
      setText(title, filename || 'A clear look before you print.');
      setText(note, src && src === failedSrc ? 'Preview unavailable. Your original artwork selection is unchanged.' : selected ? (safe ? 'Your attached artwork, fitted to the selected sheet for reference.' : 'Your original file is attached. This format has no image preview.') : pending ? 'Preview only — finish attaching your file using the artwork controls.' : 'Choose your finished sheet using the artwork controls. Supported image previews appear here.');
    };
    art?.addEventListener('error', () => { art.hidden = true; empty.hidden = false; failedSrc = art.getAttribute('src') || ''; setText(note, 'Preview unavailable. Your original artwork selection is unchanged.'); });
    let scheduled = false;
    const refresh = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; markPanels(); revealActiveBuilder(); syncSize(); syncPreview(); syncPurchase(); });
    };
    const observer = new MutationObserver(records => {
      if (records.some(record => !visual.contains(record.target))) refresh();
    });
    observer.observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'hidden', 'open', 'disabled', 'aria-disabled', 'aria-busy', 'value'] });
    document.addEventListener('fp:vault-selection-changed', refresh);
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
